export function scrollToId() {
    let url = window.location.href
    let regex = /#[^#]*[^#]$/;
    let matches = regex.test(url)
    if (matches) {
        let id_page = url.substring(url.indexOf("#") + 1);
        let element = document.getElementById(id_page)
        element?.scrollIntoView()
    }
}
